import { Card, CardBody } from "@chakra-ui/react";
import { useStytch } from "@stytch/react";
import {
  AuthFactorInstanceProps,
  WebauthnAuthFactorInstance,
} from "features/auth/AuthFactor";
import {
  getStytchErrorMessage,
  getStytchSessionDurationMinutes,
} from "features/auth/StytchUtils";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { LoadingState } from "shared/components/empty/LoadingState";
import { useToast } from "shared/components/toast/useToast";

export const AuthFactorWebauthn: React.FC<
  AuthFactorInstanceProps<WebauthnAuthFactorInstance>
> = ({ onSuccess, onCancel, rememberDevice }) => {
  const { t } = useTranslation(["common", "auth"]);
  const stytchClient = useStytch();
  const { showErrorToast } = useToast();

  const didStartAuthenticateRef = useRef(false);

  useEffect(() => {
    const startAuthenticate = async () => {
      try {
        await stytchClient.webauthn.authenticate({
          session_duration_minutes:
            getStytchSessionDurationMinutes(rememberDevice),
        });
        onSuccess();
      } catch (e) {
        showErrorToast(getStytchErrorMessage(t, e));
        onCancel();
      }
    };
    if (didStartAuthenticateRef.current) {
      return;
    }
    didStartAuthenticateRef.current = true;
    void startAuthenticate();
  }, [onCancel, onSuccess, rememberDevice, showErrorToast, stytchClient, t]);

  return (
    <Card width="md">
      <CardBody py="48px">
        <LoadingState />
      </CardBody>
    </Card>
  );
};
